import { useScreenSize } from '~/hooks/use-screen-size';
import React from 'react';

import { OrganisationPageWrapper } from '../organisation-page';
import { OrganisationSettingsSidebar } from './sidebar';

export type Props = {
  children: React.ReactNode;
  title?: string;
};

export const OrganisationSettingsPageWrapper: React.FC<Props> = (props) => {
  let { children, title } = props;

  return (
    <OrganisationPageWrapper title={title}>
      <div className="block md:flex">
        <div>
          <OrganisationSettingsSidebar />
        </div>
        <div className="px-8 py-6 w-full min-h-screen">
          {children}
          <div className="h-48"></div>
        </div>
      </div>
    </OrganisationPageWrapper>
  );
};
